export default __webpack_public_path__ + "static/media/modal_error_bg.3fd317e4.svg";